// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistance-container {
  width: 100%;
  padding: 2rem 3.5rem;
}

.assistance-container h1 {
  margin-bottom: 3rem;
}

.faq-header,
.glossary-item-header {
  background-color: #595959;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem;
  color: #fffdfc;
  font-size: 2rem;
}

.faq-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-content {
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  /* padding: 2rem; */
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

/* .faq-question {
  padding: 1rem 1.5rem;
} */

.faq-question:last-of-type {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.faq-question:hover {
  background-color: #f2f2f2;
}

.faq-question button {
  text-align: start;
  width: 100%;
  padding: 1.5rem;
}

.faq-question-text {
  font-weight: 600;
}

.faq-answer {
  margin-top: 1rem;
}

.active-question {
  background-color: #f2f2f2;
}

.glossary {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 colonnes */
  gap: 20px; /* espace entre les items */
  margin-top: 20px;
}

.glossary-item {
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.glossary-item-content {
  padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Assistance/Assistance.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,eAAe;EACtD,SAAS,EAAE,2BAA2B;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".assistance-container {\n  width: 100%;\n  padding: 2rem 3.5rem;\n}\n\n.assistance-container h1 {\n  margin-bottom: 3rem;\n}\n\n.faq-header,\n.glossary-item-header {\n  background-color: #595959;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  padding: 1rem;\n  color: #fffdfc;\n  font-size: 2rem;\n}\n\n.faq-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-content {\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  /* padding: 2rem; */\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  /* gap: 8px; */\n}\n\n/* .faq-question {\n  padding: 1rem 1.5rem;\n} */\n\n.faq-question:last-of-type {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.faq-question:hover {\n  background-color: #f2f2f2;\n}\n\n.faq-question button {\n  text-align: start;\n  width: 100%;\n  padding: 1.5rem;\n}\n\n.faq-question-text {\n  font-weight: 600;\n}\n\n.faq-answer {\n  margin-top: 1rem;\n}\n\n.active-question {\n  background-color: #f2f2f2;\n}\n\n.glossary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* 3 colonnes */\n  gap: 20px; /* espace entre les items */\n  margin-top: 20px;\n}\n\n.glossary-item {\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.glossary-item-content {\n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
